import { Section } from '../common/Section'
import { Eyebrow } from '../common/Eyebrow'
import { SplitHeading } from '../animation/SplitHeading'
import { Reveal } from '../animation/Reveal'
import { Button } from '../common/Button'
import { Icon } from '../common/Icon'
import { LeafMark } from '../common/Logo'
import { company } from '../../data/company'

export function AboutPreview() {
  return (
    <Section
      className="grain relative overflow-hidden bg-brand-900 py-section text-white"
      containerClassName="grid items-center gap-12 lg:grid-cols-2"
    >
      <LeafMark className="pointer-events-none absolute -right-16 -top-10 h-96 w-96 rotate-12 text-white/[0.04]" />
      <div className="relative">
        <Eyebrow tone="light">Our story</Eyebrow>
        <SplitHeading
          as="h2"
          text="A company rooted in the rhizosphere."
          className="mt-4 font-display text-h1 font-semibold text-white"
        />
        <p className="mt-6 max-w-lg text-lead text-white/75">{company.mission}</p>
        <div className="mt-8">
          <Button to="/about" variant="primary" size="lg">
            Read our story <Icon name="ArrowRight" className="h-5 w-5" />
          </Button>
        </div>
      </div>

      <Reveal className="relative grid gap-4 sm:grid-cols-2" stagger={0.12} y={24}>
        {company.milestones.map((m) => (
          <div key={m.title} className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
            <span className="text-eyebrow font-semibold uppercase tracking-[0.18em] text-brand-300">{m.label}</span>
            <h3 className="mt-3 font-display text-lg font-semibold text-white">{m.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/65">{m.body}</p>
          </div>
        ))}
      </Reveal>
    </Section>
  )
}
